import { motion } from "framer-motion";
import { Camera, FileText, Truck } from "lucide-react";

const STEPS = [
  { n: "01", icon: Camera, title: "Stuur een foto", desc: "Vul het formulier in, voeg een foto toe van wat weg moet en geef je adres door. Klaar in één minuut." },
  { n: "02", icon: FileText, title: "Ontvang je offerte", desc: "Wij bekijken je aanvraag en sturen binnen 2 uur een eerlijke, vaste prijs. Geen verrassingen achteraf." },
  { n: "03", icon: Truck, title: "Wij ruimen alles op", desc: "We spreken een moment af, laden alles in en zorgen voor correcte verwerking en recycling." },
];

export default function HowItWorks() {
  return (
    <section id="hoe-het-werkt" className="border-y border-white/10 bg-coal/50" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 py-20 lg:px-8 lg:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <p className="font-mono text-xs uppercase tracking-[0.25em] text-brand">// Zo simpel werkt het</p>
          <h2 className="mt-3 font-display text-4xl font-black uppercase tracking-tight text-paper sm:text-5xl lg:text-6xl">
            In 3 stappen <span className="text-brand">opgeruimd</span>
          </h2>
        </motion.div>
        <div className="mt-14 grid grid-cols-1 gap-px bg-white/10 md:grid-cols-3">
          {STEPS.map((s, i) => (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.15 }}
              className="group relative bg-ink p-8 transition-colors duration-300 hover:bg-coal"
              data-testid={`step-card-${s.n}`}
            >
              <div className="flex items-start justify-between">
                <s.icon className="h-8 w-8 text-brand" />
                <span className="font-display text-7xl font-black leading-none text-white/10 transition-colors duration-300 group-hover:text-brand/30">{s.n}</span>
              </div>
              <h3 className="mt-10 font-display text-2xl font-extrabold uppercase tracking-tight text-paper">{s.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-muted2">{s.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
